import { Timestamp } from 'firebase/firestore'

/**
 * Convert a Firestore Timestamp (or Date/string/number) to a JS Date.
 * When `optional` is true, undefined/null values pass through as undefined.
 */
export function toDate(val: unknown): Date
export function toDate(val: unknown, optional: true): Date | undefined
export function toDate(val: unknown, optional?: true): Date | undefined {
  if (val == null) return optional ? undefined : new Date()
  if (val instanceof Timestamp) return val.toDate()
  if (val instanceof Date) return val
  return new Date(val as string | number)
}

/**
 * Extract { id, ...data() } from a Firestore document snapshot.
 * Use for simple types that don't need Timestamp conversion.
 */
export function docData<T>(doc: {
  id: string
  data(): Record<string, unknown>
}): T & { id: string } {
  return { id: doc.id, ...doc.data() } as T & { id: string }
}
